__turbopack_context__.v({
  "className": "tajawal_3682dd82-module__JKzdNq__className",
  "variable": "tajawal_3682dd82-module__JKzdNq__variable",
});
